import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { getAdminApiConfig } from '../helpers/config';
const adminConfig = getAdminApiConfig();
const vm_port = localStorage.getItem('port_no');

const adminApiClient = new ApolloClient({
    // uri: `${process.env.REACT_APP_SHOPIFY_ADMIN_API_PROXY_URI}`,
    uri: adminConfig.uri,
    cache: new InMemoryCache(),
    // add headers for basic auth
    headers: {
        "Region": adminConfig.region,
        'Authorization': `Basic ${btoa(`${adminConfig.userName}:${adminConfig.accessToken}`)}`,
    },
});

// get inventory item id
const INVENTORY_ITEM = gql`
    query getProductVariant($id: ID!) {
    productVariant(id: $id) {
        id
        inventoryItem {
            id
        }
    }
}
`;

function getInventoryItemByVariantId($variantId) {
    try {
        return adminApiClient.query({
            query: INVENTORY_ITEM,
            variables: {
                id: $variantId,
            },
        });

    } catch (error) {
        console.error('Error fetching inventory item:', error);
        throw error;
    }
}

// inventorySetOnHandQuantities
const INVENTORY_SET_ON_HAND_QUANTITIES = gql`
    mutation inventorySetOnHandQuantities($input: InventorySetOnHandQuantitiesInput!) {
        inventorySetOnHandQuantities(input: $input) {
            userErrors {
                field
                message
            }
            inventoryAdjustmentGroup {
                createdAt
                reason
                referenceDocumentUri
                changes {
                    name
                    delta
                }
            }
        }
    }
`;

async function setOnHandQuantitiesOfProduct(locationId, inventoryItemId, quantity, reason = 'restock') {
    try {
        const result = await adminApiClient.mutate({
            mutation: INVENTORY_SET_ON_HAND_QUANTITIES,
            variables: {
                input: {
                    reason,
                    setQuantities: [
                        {
                            locationId,
                            inventoryItemId,
                            quantity
                        }
                    ]
                }
            },
        });
        console.log('Inventory on hand:', result.data.inventorySetOnHandQuantities.inventoryItem);
        return result.data.inventorySetOnHandQuantities.inventoryItem;
    } catch (error) {
        console.error('Error setting on hand quantities:', error);
        throw error;
    }
}


const UPDATE_META_OBJECT = gql`
    mutation UpdateMetaobject($id: ID!, $metaobject: MetaobjectUpdateInput!) {
    metaobjectUpdate(id: $id, metaobject: $metaobject) {
        metaobject {
            handle
            # coil_setting: field(key: "coil_setting") {
            #     value
            # }
        }
        userErrors {
            field
            message
            code
        }
    }
}
`;

function updateMetaObjectCoilSetting($coilSetting) {
    return adminApiClient.mutate({
        mutation: UPDATE_META_OBJECT,
        variables: {
            "id": `gid://shopify/Metaobject/${adminConfig.gidNo}`,
            "metaobject": {
                "fields": [
                    {
                        "key": "coil_setting",
                        "value": JSON.stringify($coilSetting)
                    }
                ]
            }
        }
    });
}

const ORDER_CREATE = gql`
    mutation OrderCreate($order: OrderCreateOrderInput!, $options: OrderCreateOptionsInput) {
        orderCreate(order: $order, options: $options){
            order {
                id
                displayFinancialStatus
                fulfillmentOrders(first: 10) { 
                    edges {
                        node {
                            id
                            lineItems (first:10) {
                                edges{
                                    node{
                                        id 
                                        productTitle
                                        totalQuantity
                                        inventoryItemId
                                        
                                    }
                                }
                            }
                        }
                    }
                }
                lineItems (first: 5) {
                    edges{
                        node{
                            id
                            name
                            title
                            quantity
                        }
                    }
                }
            }
            userErrors {
                field
                message
            }
        }
    }
`;

function createPaidOrder(variantId, paymentAmount, gatewayName, currencyCode) {
    return adminApiClient.mutate({
        mutation: ORDER_CREATE,
        variables: {
            "order": {
                "metafields": [
                    {
                        "namespace": "order",
                        "key": "vm_port",
                        "type": "number_integer",
                        "value": vm_port
                    }
                ],
                "lineItems": [
                    {
                        "variantId": variantId,
                        "quantity": 1
                    }
                ],
                "financialStatus": "PAID",
                "transactions": {
                    "amountSet": {
                        "shopMoney": {
                            "amount": paymentAmount,
                            "currencyCode": currencyCode
                        }
                    },
                    "gateway": gatewayName,
                    "status": "SUCCESS"
                }
            },
            "options": {
                "inventoryBehaviour": "DECREMENT_OBEYING_POLICY"
            }
        },
    });
}

const FULLFILLMENT_CREATE = gql`
    mutation FulfillmentCreate ($fulfillment: FulfillmentInput!) {
        fulfillmentCreate(fulfillment: $fulfillment) {
            fulfillment {
                id
                status
                deliveredAt
            }
            userErrors {
                field
                message
            }
        }
    }
`;

function createFulfillment($fulfillmentOrderId, $fulfillmentOrderLineItemsId) {
    return adminApiClient.mutate({
        mutation: FULLFILLMENT_CREATE,
        variables: {
            "fulfillment": {
                "lineItemsByFulfillmentOrder": [
                    {
                        "fulfillmentOrderId": $fulfillmentOrderId,
                        "fulfillmentOrderLineItems": [
                            {
                                "id": $fulfillmentOrderLineItemsId,
                                "quantity": 1
                            }
                        ]
                    }
                ]
            }
        }
    });
}

const FULFILLMENT_CREATE_V2 = gql`
    mutation FulfillmentCreateV2($fulfillment: FulfillmentV2Input!) {
        fulfillmentCreateV2(
            fulfillment: $fulfillment
        ) {
            fulfillment {
                id
                status
                deliveredAt
            }
            userErrors {
                field
                message
            }
        }
    }
`;

function createFulfillmentV2($fulfillmentOrderId) {
    return adminApiClient.mutate({
        mutation: FULFILLMENT_CREATE_V2,
        variables: {
            "fulfillment": {
                "lineItemsByFulfillmentOrder": {
                    "fulfillmentOrderId": $fulfillmentOrderId
                }
            }
        }
    });
}

export {
    createPaidOrder,
    createFulfillment,
    createFulfillmentV2,
    updateMetaObjectCoilSetting,
    getInventoryItemByVariantId,
    setOnHandQuantitiesOfProduct
};